<template>
  <v-container v-if="useAuthStore().isTestEnv || !useAuthStore().isStaff">
    <users-list-card
  /></v-container>
</template>
<script lang="ts" setup>
import UsersListCard from "@/users/components/user-management/UserListCard.vue";
import { useAuthStore } from "@/auth/stores/auth";
</script>
